// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useContext, useEffect, useState} from 'react';
import cn from 'classnames';
import {img_url} from '../../../ui/img_url';
import {Settings_context} from '../../../settings_ctx';
import {Button} from '../../../lib/button';
import styles from '../../../products/products.module.less';
import {guess_os_and_version} from '../../../client_hints_global';
import {mobile_links} from '../../../ui/use_install_info';
import {guess_browser} from 'zuser_agent';
import {perr_www_visit} from 'hola_pub_util';
import {Link} from '../../../ui/link';

const get_link_by_os_and_device = (os: string, device: string)=>{
    if (mobile_links[os])
        return mobile_links[os];
    if (mobile_links[device])
        return mobile_links[device];
    if (os==='macos')
      return mobile_links['ios'];
    return mobile_links.all;
};

export const Root = ()=>{
    const {theme} = useContext(Settings_context);
    const [has_app, set_has_app] = useState(false);
    useEffect(()=>{
        perr_www_visit({id: 'www_products_discover_visit'});
        if ('getInstalledRelatedApps' in navigator)
        {
            // @ts-ignore
            navigator.getInstalledRelatedApps().then(related_apps=>{
              set_has_app(related_apps.length>0);
            });
        }
    }, []);
    const sys = guess_os_and_version();
    const b = guess_browser();
    const os = sys.os==='ios' || sys.os==='macos' && sys.mobile ? 'iOS'
      : 'Android';
    const link = get_link_by_os_and_device(sys.os, b.huawei ? 'huawei' :
      b.samsung ? 'samsung': 'all');
    const cta = has_app ? `Start using Hola` : `Get Hola for ${os}!`;
    return <div className={styles.discover_root}>
      <img src={img_url('hola2023/discover_products.svg')}
        className={cn(styles.top_img, 'lazyload')} alt="products"/>
      <h2>Hola, because Access shouldn't depend on where you are.</h2>
      <p className={cn(theme.u2, styles.description_discover)}>In your pocket,
        while on the go, on your desktop
        or Smart TV, Hola is there to get you the content you want, no
        matter what device you prefer.</p>
      <div className={styles.discover_block}>
        <Link to={'/products/extension'}>
          <img src={img_url('hola2023/products_discover_ext.svg')}
            alt="ext" className="lazyload"/>
          <p className={cn(theme.u2, styles.description_block_title)}>
            Browser Extensions
          </p>
          <p className={cn(theme.p2, theme.reg)}>For Chrome, Opera and
            Microsoft Edge</p>
        </Link>
      </div>
      <div className={styles.discover_block}>
        <Link to={'/products/mobile'}>
          <img src={img_url('hola2023/products_discover_mobile.svg')}
            alt="mobile" className="lazyload"/>
          <p className={cn(theme.u2, styles.description_block_title)}>
            Phone Apps
          </p>
          <p className={cn(theme.p2, theme.reg)}>For iOS, Samsung and Huawei
            </p>
        </Link>
      </div>
      <div className={styles.discover_block}>
        <Link to={'/products/desktop'}>
          <img src={img_url('hola2023/products_discover_desktop.svg')}
            alt="desktop" className="lazyload"/>
          <p className={cn(theme.u2, styles.description_block_title)}>
            Desktop Apps
          </p>
          <p className={cn(theme.p2, theme.reg)}>For Windows and Mac</p>
        </Link>
      </div>
      <div className={styles.discover_block}>
        <Link to={'/products/tv'}>
          <img src={img_url('hola2023/products_discover_tv.svg')}
            alt="tv" className="lazyload"/>
          <p className={cn(theme.u2, styles.description_block_title)}>
            TV Apps
          </p>
          <p className={cn(theme.p2, theme.reg)}>For Fire TV, LG TV, Apple TV
            and Smart TV</p>
        </Link>
      </div>
      <div className={styles.discover_block}>
        <Link to={'/products/console'}>
          <img src={img_url('hola2023/products_discover_others.svg')}
            alt="others" className="lazyload"/>
          <p className={cn(theme.u2, styles.description_block_title)}>
            More Products
          </p>
          <p className={cn(theme.p2, theme.reg)}>Gaming apps, routers and
            smart DNS</p>
        </Link>
      </div>
      <Button caption={cta} color={'black2023'} size={'lg'}
        on_click={()=>{
          window.location.href = link;
        }}/>
    </div>;
};

Root.meta = {
  default_theme: 'hola2023',
  meta: {
      title: 'Hola, because Access shouldn\'t depend on where you are.',
      description: 'In your pocket, while on the go, on your desktop or '+
      'Smart TV, Hola is there to get you the content you want, no matter'+
      ' what device you prefer.',
      canonical_url: 'https://hola.org/products/discover',
  },
};
